// @flow
const ELECTRON_HOSTNAME = ''

function inDevelopment (): boolean {
  const { hostname } = document.location
  return hostname === 'localhost' || hostname.startsWith('192') || hostname === ELECTRON_HOSTNAME
}

export default inDevelopment()



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/modules/in-development.js